import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import "./index.scss";
import { clearSelectedDataKey, setSelectedData } from "redux/formDisplay";
import Label from "lib/Label";
import ErrorMessage from "lib/ErrorMessage";

const CustomDatePicker = (props) => {
  const {
    name,
    value,
    label,
    onChange,
    class_name,
    error,
    placeholder,
    events,
    //Donot remove selectedData as it is being used from the config in the eval part of code below
    selectedData,
    size,
    is_disabled,
    validators,
    custom_value,
    isEditable, // is used when RM requests to resend certain fields to the applicant
    // when editable is true only that field will be editable and rest will be disabled
  } = props;
  const mandatoryExtraction = useSelector(
    (state) => state?.formData?.mandatoryExtraction
  );
  const [minDate, setMinDate] = useState();
  const [maxDate, setMaxDate] = useState();
  const [filterDate, setFilterDate] = useState(false);
  const errActive = error && error?.length !== 0;
  const errorClass = errActive ? "error_outline" : "";
  const dispatch = useDispatch();
  let validFrom = selectedData?.[name?.replace("to", "from")];
  if (name.includes("valid_from")) validFrom = null;
  let dateValue = eval(validators?.date_value);

  const handleChange = (date) => {
    date = date || new Date();
    const dependent_field_expression = events?.onKeyUpCapture;
    let isoDate = moment(date).format("DD/MM/YYYY");
    let isoString = new Date(date).toISOString();
    let saveDate = true;
    if (saveDate) onChange(isoDate, name);
  };

  let dateArray = [];
  let ValidFromArray = [];
  let dataValue = value && value?.split("/");
  value && dateArray.push(dataValue[1]);
  value && dateArray.push(dataValue[0]);
  value && dateArray.push(dataValue[2]);

  let dataValidfrom = validFrom && validFrom?.split("/");
  validFrom && ValidFromArray.push(dataValidfrom[1]);
  validFrom && ValidFromArray.push(dataValidfrom[0]);
  validFrom && ValidFromArray.push(dataValidfrom[2]);

  const filterDates = (date) => {
    return date.getDate() === parseInt(dateValue);
  };

  const handleOpenCalender = () => {
    if(name.includes("valid_from")){
      setMinDate(new Date());
    } else if(name.includes("valid_to")){
      setMaxDate(new Date());
    } else if(name.includes("first_collection_date")){
      if(selectedData["final_collection_date"]){
        dispatch(clearSelectedDataKey({key: "final_collection_date"}))
      }
      if(name.includes("physical_nach")){
        if(eval(validators?.min_length) || eval(validators?.max_length)){
          let dateValue = eval(validators?.min_length) || eval(validators?.max_length);
          let date = new Date();
          setMaxDate(new Date(date.getFullYear(), date.getMonth() - 1, 1));
          setFilterDate(true);
        } else {
          let date = new Date();
          setMaxDate(new Date(date.getFullYear(), date.getMonth() - 1, 1));
        }
      } else {
        if(eval(validators?.min_length) || eval(validators?.max_length)){
            setMaxDate(new Date());
            setFilterDate(true);
        } else setMaxDate(new Date());
      }
    } else if(name.includes("final_collection_date")){
      if(eval(custom_value)){
        let dateData = eval(custom_value).split("/");
        let year = dateData[2];
        let month = dateData[1];
        let day = dateData[0]
        let date = new Date(year, month-1, day);
        if(date < new Date()){
          let date = new Date();
          let new_date = date.setDate(date.getDate() + 1);
          setMaxDate(new Date(new_date));
        } else {
          let new_date = date.setDate(date.getDate() + 1);
          setMaxDate(new Date(new_date));
        }
      } else {
        let date = new Date();
        let new_date = date.setDate(date.getDate() + 1);
        setMaxDate(new Date(new_date));
      }
    }
  }

  return (
    <div className={size}>
      <Label label={label} validators={validators} />
      <div className="date_container">
        <DatePicker
          onCalendarOpen={handleOpenCalender}
          onChange={(date) => handleChange(date)}
          maxDate={minDate}
          minDate={maxDate}
          className={`input_datepicker ${errorClass} ${class_name} ${
            !isEditable && "radioDisabled"
          }`}
          value={value}
          filterDate={filterDate && filterDates}
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          dateFormat="dd/MM/yyyy"
          placeholderText={"--/--/----"}
          disabled={
            selectedData &&
            is_disabled &&
            is_disabled !== undefined &&
            eval(is_disabled)
              ? true
              : isEditable
              ? false
              : true
          }
          onKeyDown={(e) => {
            e.preventDefault();
          }}
        />
        {error?.length !== 0 && <ErrorMessage error={error} />}
      </div>
    </div>
  );
};

export default CustomDatePicker;
